// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".screen-fit[data-v-5c25f5e9]{position:relative;width:100vw;height:100vh;overflow:hidden;background:#020816}.screen-fit__canvas[data-v-5c25f5e9]{position:absolute;top:0;left:0;transform-origin:left top;overflow:hidden}", ""]);
// Exports
module.exports = exports;
